module.exports = __webpack_public_path__ + "img/emoji_48.948aa661.png";